export default __webpack_public_path__ + "assets/c2Screenshot.9a7a0fed.png";